import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IncomeaddPage } from './incomeadd.page';

const routes: Routes = [
  {
    path: '',
    component: IncomeaddPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IncomeaddPageRoutingModule {}
